import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useState, useCallback, useRef, useEffect } from 'react';
import { BodyTextSmall, HeadingText30 } from '../Typography/Typography';
import * as styles from './RangePicker.module.scss';
const Name = 'RangePicker';
export const RangePicker = ({ range, onValueChange, minLabel, middleLabel, maxLabel, labelId, className, }) => {
    const [selectedValue, setSelectedValue] = useState();
    const selectedOptionRef = useRef(null);
    const [fillWidth, setFillWidth] = useState(0);
    const calculateFillWidth = useCallback((selectedElement) => {
        const rangeContainer = selectedElement.offsetParent;
        const { left } = rangeContainer.getBoundingClientRect();
        const { right } = selectedElement.getBoundingClientRect();
        /** Account for box sizing borders and padding. Hardcode for now */
        const margins = 6;
        return right - left + margins;
    }, []);
    const resizeFill = useCallback(() => {
        if (!selectedOptionRef.current) {
            return;
        }
        const newFillWidth = calculateFillWidth(selectedOptionRef.current);
        setFillWidth(newFillWidth);
    }, [calculateFillWidth, selectedOptionRef]);
    /**
     * Re-draw fill when screen is resized
     */
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', resizeFill);
        resizeFill();
        return () => window.removeEventListener('resize', resizeFill);
    }, [range, selectedOptionRef, resizeFill]);
    const handleSelect = (value, event) => {
        selectedOptionRef.current = event.currentTarget.parentElement;
        setSelectedValue(value);
        resizeFill();
        if (onValueChange) {
            /** allow animation to finish */
            setTimeout(() => onValueChange(value), 250);
        }
    };
    return (_jsxs("fieldset", { className: clsx(styles.container, className), "data-component": Name, children: [_jsxs("div", { className: styles.labelsContainer, children: [minLabel && (_jsx(BodyTextSmall, { className: styles.minLabel, fontColor: "gray65", children: minLabel })), middleLabel && (_jsx(BodyTextSmall, { centered: true, fontColor: "gray65", children: middleLabel })), maxLabel && (_jsx(BodyTextSmall, { className: styles.maxLabel, fontColor: "gray65", children: maxLabel }))] }), _jsxs("div", { className: styles.rangeWrapper, children: [_jsx("div", { className: styles.fillRange, style: { width: fillWidth } }), _jsx("div", { "aria-labelledby": labelId, className: styles.rangeContainer, role: "radiogroup", children: [...Array(range)].map((_, index) => {
                            const optionValue = index + 1;
                            const isOptionSelected = optionValue === selectedValue;
                            return (_jsxs("label", { className: styles.rangeElement, children: [_jsx("input", { type: "radio", checked: isOptionSelected, onChange: event => handleSelect(optionValue, event), value: optionValue }), _jsx(HeadingText30, { as: "span", children: optionValue })] }, optionValue));
                        }) })] })] }));
};
